export default "__VITE_ASSET__Zh_b084K__"